module.exports = __webpack_public_path__ + "media/application/images/public_square/logo_nav-83fc91d701a573ae5b2b4f529272fe59.png";